import {
  InfiniteData,
  useInfiniteQuery,
  UseInfiniteQueryResult
} from '@tanstack/react-query';
import axios from 'axios';
import { Message } from 'common/types';
import { alyviaCoreServiceApi } from 'utils/constants';

interface FetchConversationMessagesParams {
  deviceId: string;
  limit: number;
  cursor?: string;
  markAllReceivedMessageAsRead: boolean;
}

async function fetchConversationMessages(
  deviceId: string,
  conversationId: string,
  cursor?: string,
): Promise<Message[]> {
  const params: FetchConversationMessagesParams = {
    deviceId,
    markAllReceivedMessageAsRead: true,
    limit: 50,
  };

  if (cursor) params.cursor = cursor;

  const { data } = await axios.get(
    `${alyviaCoreServiceApi}/messages/${conversationId}`,
    { params },
  );

  return data;
}

export function useConversationMessages(
  deviceId: string,
  conversationId: string,
): UseInfiniteQueryResult<InfiniteData<Message[], Error>> {
  return useInfiniteQuery({
    queryKey: ['messages', conversationId, deviceId], // unique key cache
    queryFn: ({ pageParam = null }) =>
      fetchConversationMessages(deviceId, conversationId, pageParam),
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (lastPage?.length > 0) {
        return lastPage[lastPage?.length - 1].id;
      }
    },
    // getPreviousPageParam: (firstPage) => {
    //   return firstPage?.meta ? firstPage?.data[0]?.id : null;
    // },
    placeholderData: (prevData) => prevData,
    refetchInterval: 10000,
    staleTime: 5000, // Time that data is considered "fresh" before a new fetch
    enabled: !!deviceId && !!conversationId,
  });
}
